//default allowed types
export const isValidFileExtention = (fileName: string, validExt = ["txt", "rtf", "doc", "docx", "pdf"]) => {
    let fileExt = fileName.split(".").pop();
    return validExt.some((item) => item === fileExt);
  };